module.exports = __webpack_public_path__ + "7824dca305998d2c0b45505eeca44c14.png";